// oxlint-disable require-await
import {dialog} from '@cypro/ui/components'
import {DeleteResourceDialog} from '@cypro/ui/components'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {DeleteResourceSchema} from '@cypro/engine/mutators/util'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useDeletePharmacy() {
  const zero = useZero()

  return useCallback(
    async (payload: DeleteResourceSchema) =>
      zero.attemptMutation(zero.mutators.pharmacies.deleteBatch({pharmacyIds: [payload.id]}), async ({server}) => {
        const result = await server
        return result
      }),
    [zero]
  )
}

export function useConfirmDeletePharmacy() {
  const {t} = useTranslate('common')
  const deletePharmacy = useDeletePharmacy()

  return useCallback(
    async (payload: DeleteResourceSchema) => {
      const confirmed = await dialog.open(payload.id, {
        children: (
          <DeleteResourceDialog
            id={payload.id}
            title={t('delete_pharmacy.title')}
            description={t('delete_pharmacy.description')}
          />
        ),
      })
      if (!confirmed) throw new Error('User did not confirm')

      const deleteRes = await deletePharmacy(payload)
      if (!deleteRes) throw new Error('Unexpected error')
      if (deleteRes.type === 'error') throw deleteRes.error
    },
    [t, deletePharmacy]
  )
}
